import addExternalScript from 'lib/utils/external-script'
import env from 'config/env'

export async function getKlinkAuthUser(user) {
  if (!user?.id_customer) {
    return undefined
  }

  try {
    const response = await fetch('/server/klink-identity', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ identity: user.id_customer }),
    })

    if (!response.ok) {
      return undefined
    }

    const { identity, userHash } = await response.json()

    return {
      identity,
      userHash,
      name: [user.firstname, user.lastname].filter(Boolean).join(' '),
      email: user.email,
    }
  } catch (error) {
    return undefined
  }
}

// The SDK finishes setting up its widget DOM asynchronously after `run()`
// returns, so calling `openWidget()` immediately after this resolves can be a
// no-op. This gives it a moment to finish initializing before we let the
// caller proceed to open the widget.
const KLINK_WIDGET_INIT_DELAY_MS = 500

export async function loadKlinkScript(user) {
  const scriptTag = document.getElementById('klink-chat-widget')

  if (scriptTag) {
    return
  }

  const authUser = await getKlinkAuthUser(user)

  await new Promise((resolve) => {
    addExternalScript(
      `https://chat.klink.cloud/klink-chat-widget.embed.latest.js?v=${new Date().getTime()}`,
      'klink-chat-widget',
      () => {
        if (window.klinkChatSDK?.run) {
          window.klinkChatSDK.run({
            serverUrl: env.KLINK_SERVER_URL,
            scId: env.KLINK_SC_ID,
            showLaunchButton: false,
            ...(authUser && { authUser }),
          })
          setTimeout(resolve, KLINK_WIDGET_INIT_DELAY_MS)
        } else {
          resolve()
        }
      },
    )
  })
}

export default getKlinkAuthUser
